module.exports = import("https://cdn.sheetjs.com/xlsx-0.19.2/package/xlsx.mjs");;